import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/map';

declare var google:any;

@Injectable()
export class LocationProvider {

  constructor(public http: Http) {  }

  load() :Observable<any> {
    return this.http.get(`https://services.arcgis.com/WNsrZDHEJ88NE4N8/ArcGIS/rest/services/Espais_lliures_pol%C3%ADgons/FeatureServer/0/query?where=1%3D1&objectIds=&time=&geometry=&geometryType=esriGeometryPoint&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&returnGeodetic=false&outFields=OBJECTID%2CPoligon%2CAdre%C3%A7a_ubi%2CTipologia%2CSup_interv%2CSuperf_m2%2CR%C3%A8gim_prop%2CDisponibil%2CEmpresa_Im%2CTl_1contac%2CTl_2contac%2CE_mail%2CContacte%2CDescripci%C3%B3%2Cfoto%2Cweb_immob&returnGeometry=true&returnCentroid=false&multipatchOption=none&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnDistinctValues=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&quantizationParameters=&sqlFormat=none&f=pgeojson&token=`).map(res => <any>res.json());
  }
}



// WEBPACK FOOTER //
// ./src/providers/locationProvider.ts